import * as z from "zod/v4";

export const createCin7OmniIntegration = {
  name: "createCin7OmniIntegration" as const,
  input: z.object({
    apiUsername: z.string().min(1),
    apiKey: z.string().min(1),
  }),
  output: z.object({ success: z.boolean() }),
};
